export const fetchPlan = async (
  planoId: string,
  VendedorId: string,
): Promise<any> => {
  const urlBaseApiV2 = process.env.REACT_APP_OG_API_URL;
  if (planoId && VendedorId) {
    const response = await fetch(`
        ${urlBaseApiV2}/info/getPlansSeller?vendedorId=${VendedorId}&produtoComercial=${planoId}`);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    const urlPlan = process.env.REACT_APP_OG_GET_PLAN_DETAILS_SERVER;
    const Plan = await fetch(`${urlPlan}${data.cd_Codtokenidparc}`);

    const retorno = await Plan.json();
    return retorno;
  }
};
